<template>
	<v-card class="card-rounded elevation-1 mb-3 justify-bottom text-left" style="width: 100%">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1"
					><h2>{{ value }}% complete</h2></v-list-item-title
				>
				<v-spacer></v-spacer>
				<v-progress-linear
					:active="true"
					:background-opacity="0.15"
					:height="24"
					:striped="false"
					:rounded="true"
					:value="value"
					background-color="grey"
					class="progress-rounded"
					:buffer-value="value + this.per_step_value"
				>
				</v-progress-linear>
			</v-list-item-content>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

export default {
	components: {},
	data: () => ({
		initial: 0,
	}),

	computed: {
		steps: function () {
			return store.getters.stepsRequiredCompany.length + 2;
		},
		step: function () {
			let count = 0;
			store.getters.stepsRequiredCompany.forEach(step => {
				if (step.status) {
					count++;
				}
			});
			return count;
		},

		per_step_value: function () {
			return Math.floor((1 / this.steps) * 100);
		},

		value: function () {
			let count = 0;
			store.getters.stepsRequiredCompany.forEach(step => {
				if (step.status) {
					count++;
				}
			});
			return Math.min(
				100,
				count * 10 +
					this.per_step_value * 3 +
					(store.getters.getIsApprovedCompany ? this.per_step_value : 0) +
					(store.getters.currentStepCompany == 'completed-step' ? this.per_step_value : 0)
			); //+10 for initial step thats guarenteed to be done
		},
	},

	created() {
		bus.$on('update:progressbar@add', increment => {
			this.value += Math.min(increment, 100); //clamp to 100.
		});
		bus.$on('steps@refresh', () => {
			this.value = this.initial;
		});
		bus.$on('update:progressbar@steps', steps => {
			this.steps = steps;
		});
		bus.$on('account:step@register', () => {
			//increase the total step counter
			this.steps = this.steps + 1;
		});
		bus.$on('update:progressbar@set-step', step => {
			this.step = step;
			// this.step = Math.max(this.step,1); //clamp to 1 or higher
		});

		bus.$on('update:progressbar@step', () => {
			this.step = this.step + 1;
			this.step = Math.min(this.steps, this.step); //clamp to max
		});
	},

	methods: {
		SubmitForm() {
			bus.$emit('intent:submit-forms');
		},
	},
};
</script>
